import { useMemo } from 'react';
import { useLocation, matchRoutes } from 'react-router-dom';
import { breadcrumbRoutes } from '../routes';
import { BreadcrumbConfig } from '../types';

/**
 * Hook to match current location against breadcrumb route configuration
 * Uses React Router's matchRoutes to find all matching routes in the hierarchy
 * Returns flattened array of breadcrumb configs (parent + children)
 */
const useMatchedBreadcrumbs = (): BreadcrumbConfig[] | null => {
    const location = useLocation();

    return useMemo(() => {
        const matches = matchRoutes(breadcrumbRoutes, location);

        if (!matches || matches.length === 0) {
            return null;
        }

        // Flatten breadcrumbs from all matched routes (parent + children)
        const breadcrumbConfigs = matches.flatMap(match => (match.route as any).breadcrumbs || []);

        return breadcrumbConfigs;
    }, [location]);
};

export default useMatchedBreadcrumbs;
